import { useEffect } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import { useQuery, UseQueryOptions } from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import {
  getNotificationsCountKey,
  getNotificationsKey,
} from '../../utils/keys/notification.key.js'

export const useNotificationsCount = (options: {
  useQueryOptions?: UseQueryOptions<number>
}) => {
  const { useQueryOptions } = options || {}
  const { client } = useTribeClient()
  const notificationsKey = getNotificationsCountKey()

  const result = useQuery<number>(
    notificationsKey,
    () => client?.notifications.count(),
    useQueryOptions,
  )
  const queryClient = useQueryClient()

  const { data: notificationCount = 0 } = result

  useEffect(() => {
    if (notificationCount > 0) {
      queryClient.invalidateQueries(getNotificationsKey())
    }
  }, [notificationCount])

  return result
}
